<template>
  <div class="container">
    <div class="left">
      <img src="../assets/images/404.png" />
    </div>
    <div class="right">
      <div class="fontS40">403</div>
      <div class="prompt">抱歉，你无权访问该页面</div>
      <el-button type="danger" @click="goIndex">返回首页</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "error403",
    data() {
      return {}
    },
    methods: {
      //回到首页
      goIndex(){
        this.$router.push("/");
      }
    }
  }
</script>

<style scoped>
  .container {
    display: flex;
    margin-top: 200px;
    justify-content: center;
    align-items: center;
  }
  .left{
    margin-right: 50px;
  }
  .fontS40{
    font-size: 40px;
  }
  .prompt {
    font-size: 20px;
    color: #878686;
    margin: 15px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/error403.vue